import React, { useEffect } from "react";
import useHistoryData from "../../utils/fetchHistoryUtils";
import HistoryList from "../UI/history/listUI";
import lstool from "../../utils/localStorage";
const GetStatus = status => {
  switch (status) {
    case 1:
      return "تایید اولیه";
      break;
    case 2:
      return "کنسلی در تایید اولیه";
      break;
    case 5:
      return "پیگیری";
      break;
    case 4:
      return "پاسخ نداده در تایید اولیه";
      break;
    case 3:
      return "نمونه کاری";
      break;
  }
};
export default function HistoryPage({ color, status, history }) {
  const [item, hasMore, getData] = useHistoryData({
    marketerofficeid: lstool.get(),
    condition: GetStatus(status)
  });
  return (
    <HistoryList
      hasMore={hasMore}
      fetchMore={getData}
      config={item}
      color={color}
      hasReminder={status === 5}
      click={item => {
        if (status !== 1) {
          lstool.set("ReStatusNumber", item.CustomerMainMobile);
          history.push("/main/");
        }
      }}
    ></HistoryList>
  );
}
